module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Regular.766f96ed.woff";